/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/29/21
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import classNames from 'classnames';
import BasicReduxFormSelectMenu from 'components/support/forms/SelectMenus/BasicReduxFormSelectMenu';
import RenderInput from 'components/support/forms/RenderInput';

type Props = {
  items: Array<any>
}
const ScenarioSelectMenu = ({ items }: Props) => (
  <BasicReduxFormSelectMenu
    items={items}
    id="scenario"
    name="scenarioId"
    inputClassName={classNames('custom-select', 'scenario-select')}
    component={RenderInput}
  />
);

export default ScenarioSelectMenu;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryPageControlForm/ScenarioSelectMenu/ScenarioSelectMenu.jsx